// extracted by mini-css-extract-plugin
export default {"title__Style":"CommonTitle_title__Style__uBTkC","titleBorder__style":"CommonTitle_titleBorder__style__gXxml"};